import { Playground } from 'docz';
import Frame from "../../../../../src/components/Frame.tsx";
import CoffeeChart from "../../../../../src/components/CoffeeChart";
import * as React from 'react';
export default {
  Playground,
  Frame,
  CoffeeChart,
  React
};